import styled from 'styled-components';

export const WorkflowContainer = styled.div`
  align-self: center;
  margin: 16px;
  max-width: 600px;
`;
